export default {
    methods: {
        getInputAttrs(item) {
            const { facets = [], name, id, state = {} } = item;
            const { required, disabled } = state;
            const fieldState = this.state || {};

            return {
                class: facets.map(facet => this.bemAdd(facet, 'input')),
                name,
                id,
                disabled: fieldState.disabled || disabled,
                required: fieldState.required || required,
            };
        },
    },
};
